import { useFlags } from "launchdarkly-react-client-sdk";

import { useAppSelector } from "app/hooks";
import { TEAM_MENTIONS_FEATURE } from "constants/feature-flags";
import { PRE_AUTH_USER_ID, selectCurrentUser } from "features/auth/auth-slice";

/**
 * The signed-in user's id for the team @mentions launch hints, or `null` while the flag is off or
 * before the user is known. Every launch hint renders nothing on `null`, so with the flag off none
 * of them reads or writes storage.
 */
export default function useMentionsLaunchUserId(): string | null {
  const isEnabled = Boolean(useFlags()[TEAM_MENTIONS_FEATURE]);
  const userId = useAppSelector(selectCurrentUser)?.id;
  if (!isEnabled || !userId || userId === PRE_AUTH_USER_ID) return null;
  return String(userId);
}
